import { render, staticRenderFns } from "./Grouped.vue?vue&type=template&id=0bec0ddf&"
import script from "./Grouped.vue?vue&type=script&lang=ts&"
export * from "./Grouped.vue?vue&type=script&lang=ts&"
import style0 from "./Grouped.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports